import { ProcessTerminate, ProcessTerminateApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new ProcessTerminateApi(apiConfiguration(elegislativaPrefixPath));

const map = (dovodUkoncenia: string): ProcessTerminate => ({
  dovodUkoncenia,
});

// eslint-disable-next-line import/prefer-default-export
export const terminateProcess = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  dovodUkoncenia: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.terminateProcess(
    type,
    year,
    index,
    pracovnyKrokId,
    map(dovodUkoncenia),
    headers,
  );
  return {
    responseCode: status,
  };
};
